
































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';
import MyForm from '@/mixins/form';

import TsUpload from '@/components/upload.vue';
import Rules from '@/components/rules.vue';
import SelectZones from '@/components/selectzones.vue';

@Component({
  components: {
    TsUpload,
    Rules,
    SelectZones,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() bannerTypes!: any[];

  @Prop() adserverRules!: any[];

  treeData: any = [];

  rules: any[] = [];

  handleSubmit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.showTsConfirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldsValue) {
              if (_.get(fieldsValue, [key])) {
                const fieldValue = _.get(fieldsValue, [key]);

                if (fieldValue) {
                  if (key === 'rules') {
                    _.set(
                      values,
                      [key],
                      JSON.stringify(
                        _.sortBy(fieldValue, (o) => Number(o.rule_sort)),
                      ),
                    );
                  } else if (moment.isMoment(fieldValue)) {
                    _.set(
                      values,
                      [key],
                      moment(fieldValue).format('YYYY-MM-DD HH:mm:ss'),
                    );
                  } else if (_.isArray(fieldValue)) {
                    _.set(values, [key], JSON.stringify(fieldValue));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }
            }
            const res = await this.$store.dispatch('adserver/addBanner', {
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success('操作成功');
              this.handleCancel();
            } else {
              this.$message.error('操作失败');
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async loadZones() {
    const res = await this.$store.dispatch('adserver/selZones', {});
    if (res && res.Data) {
      this.treeData = res.Data;
    }
  }

  mounted() {
    this.rules = this.adserverRules;
    this.loadZones();
  }
}
